// Application-wide constants

// Cache settings
export const CACHE_VALIDITY_HOURS = 24;
export const PREDICTIONS_CACHE_KEY = 'predictions_cache';
export const PREDICTIONS_CACHE_TIMESTAMP_KEY = 'predictions_cache_timestamp';

// PostHog tracking events
export const TRACKING_EVENTS = {
  PAGE_VIEW: '$pageview',
  SESSION_STARTED: 'session_started',
  SESSION_ENDED: 'session_ended',
  USER_ENGAGED: 'user_engaged',
  PREDICTIONS_LOADED_CACHE: 'predictions_loaded_from_cache',
  PREDICTIONS_LOADED_SERVER: 'predictions_loaded_from_server',
  FILTER_CHANGED: 'filter_changed',
  AUTHOR_FILTER_CHANGED: 'author_filter_changed',
  YEAR_FILTER_CHANGED: 'year_filter_changed',
  YEAR_FILTER_RESET: 'year_filter_reset',
  PREDICTION_CLICKED: 'prediction_clicked',
  PREDICTION_MODAL_CLOSED: 'prediction_modal_closed',
};

// Engagement tracking interval (milliseconds)
export const ENGAGEMENT_TRACKING_INTERVAL = 30000; // 30 seconds

